import React, { useContext } from 'react'
import { strCol, dateCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo, isValidYearRange } from 'core'
import { connect } from 'react-redux'
import { getProcessLogInfo } from 'api/pgads.js'
import CommonScreen from './CommonScreen'
import { DatePickerContext } from 'context'
import { DatePicker } from 'antd'

const headers = [
  dateCol({
    ident: 'transDate',
    display: 'Transaction Date',
    width: 160,
    dataFormat: 'YYYY-MM-DD[T]HH:mm:SS.sssZZ',
    displayFormat: 'MM/DD/YYYY HH:mm:SS',
    isFiltered: true,
    isEditable: false,
  }),
  strCol({
    ident: 'processName',
    display: 'Process Name',
    width: 250,
    isFiltered: true,
    isEditable: false,
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'message',
    display: 'Message',
    width: 1100,
    alignment: 'left',
    ellipsis: true,
    isEditable: false,
  }),
  strCol({ ident: 'user', display: 'Modifier', isEditable: false, width: 150 }),
]

const retrieveTask = apiTargetInfo => date =>
  getProcessLogInfo(apiTargetInfo)(date)

const title = 'Process Log'

const ProcessLog = () => {
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
          // retrieve({ dates: d })
        }}
      />
    )
  }
  const beforeRetrieveValidation = ({ validYearRange }) => {
    return isValidYearRange(
      validYearRange,
      selectedDateRangePicker[0],
      selectedDateRangePicker[1]
    )
  }

  return (
    <CommonScreen
      beforeRetrieveValidation={beforeRetrieveValidation}
      key="Process Log"
      title={title}
      header={headers}
      retrieveTask={retrieveTask}
      // altBy={d => d.transDate}
      withCriteria={() => ({
        startDate: selectedDateRangePicker[0],
        endDate: selectedDateRangePicker[1],
      })}
      autoRetrieve={false}
      sortOptions={[
        { ident: 'transDate', display: 'Transaction Date', sortOrder: 'asc' },
      ]}
      withoutModify
      allowInsert={false}
      withDatePicker={false}
      screenCriteria={screenCriteria}
      isEditable={false}
      isEditableGrid={_ => false}
      isAdminScreen={false}
      heightOffset={200}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(ProcessLog)
